export enum sourceSystemEnum {
    PLM = 'PLM', // only for mobile app access.
    PLC_INFRA = 'PLC_INFRA', //for backend infra feature access like postman api calls.
    PLC_APP = 'PLC_APP', // for PLC UI login access strictly for access to UI features.
    ALL = 'ALL', // for all system access.
    OTHER = 'OTHER' // for other system access.
}